export default __webpack_public_path__ + "images/KAVEI.3a953e0.png";